/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { SOCIAL_PLATFORMS, SOCIAL_PROVIDERS } from '@repo/config/social';
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { socialPostStatusSchema } from '../social-post-schema';

const publishResultErrorSchema = z.object({
  stage: z.enum(['request', 'validation', 'provider', 'platform']),
  message: z.string(),
  retryable: z.boolean(),
});

export const publishResultSchema = z.object({
  channelId: z.number(),
  provider: z.enum(SOCIAL_PROVIDERS),
  platform: z.enum(SOCIAL_PLATFORMS),
  socialPostId: z.number(),
  status: socialPostStatusSchema,
  permalink: z.string().nullable(),
  error: publishResultErrorSchema.nullable(),
});

export type IPublishSocialVideoV1ResultError = z.infer<typeof publishResultErrorSchema>;
export type IPublishSocialVideoV1Result = z.infer<typeof publishResultSchema>;

const publishDataSchema = z.object({
  results: z.array(publishResultSchema),
});

export interface IPublishSocialVideoV1Data {
  results: IPublishSocialVideoV1Result[];
}

export const publishSocialVideoV1ResponseSchema = createApiResponseSchema(
  publishDataSchema,
) as z.ZodSchema<IAPI<IPublishSocialVideoV1Data>>;

export type IPublishSocialVideoV1Response = IAPI<IPublishSocialVideoV1Data>;
